"use client";

import { showSuccessToast } from "@/lib/toast";

const AUTH_TOAST_KEY = "elevnxi_auth_toast";

type PendingAuthToast = {
  message: string;
};

export function queueAuthToast(message: string) {
  if (typeof window === "undefined") return;
  sessionStorage.setItem(AUTH_TOAST_KEY, JSON.stringify({ message }));
}

export function flushAuthToast() {
  if (typeof window === "undefined") return;

  const raw = sessionStorage.getItem(AUTH_TOAST_KEY);
  if (!raw) return;

  sessionStorage.removeItem(AUTH_TOAST_KEY);

  try {
    const { message } = JSON.parse(raw) as PendingAuthToast;
    if (message) showSuccessToast(message);
  } catch {
    // Ignore malformed session data.
  }
}
